const initialstate = { show: false };

export default (state = initialstate, action) => {
  if (action.type === 'SHOW_LOADING') {
    return { ...state, show: action.payload };
  }

  return state;
}
